import { AuthContext } from '@exxonmobil/uit-uda-ui-components-lib';
import jwtDecode from 'jwt-decode';
import { useContext } from 'react';

export const isApprover = () => {
  const authContext = useContext(AuthContext);

  const accountInfo = authContext.data;
  const token = accountInfo.authToken;
  const decoded = jwtDecode(token) as any;
  /*
        example decoded.roles is an array
        if roles contains "Baselines.Approver", user has approve access
        so the list of existing roles is for a UDA Dev AD group we all belong to
        */

  return (decoded.roles as Array<string>).includes('Baselines.Approver');
};
